<template>
  <a-locale-provider :locale="locale">
     <a-spin :spinning="globalLoading.loading" :tip="globalLoading.tip">
       <router-view />
     </a-spin>
  </a-locale-provider>
</template>

<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import {mapState} from "vuex";

  export default {
    data() {
      return {
        locale: zhCN
      }
    },
    mounted() {
      let query = window.location.search
      if(
        query.indexOf("clientId=") >= 0 &&
        query.indexOf("appId=") >= 0 &&
        query.indexOf("insCode=") >= 0) {
          this.$store.commit("SET_HIDDEN_HEADER", false)
        }
    },
    computed: {
      ...mapState(["globalLoading"])
    }
  }
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
